import React, {useMemo} from 'react';
import {MutateClassTemplateRequest, space} from "../../../../../provider_api";
import {useProviderProfile} from "../../../../../ProviderProfileProvider";
import {useParams} from "react-router-dom";
import {EditableStringField} from "../../../../../components/Editable/EditableStringField";
import {EditableLongTextField} from "../../../../../components/Editable/EditableLongTextField";
import {
  EditableStringFieldWithSuggestions
} from "../../../../../components/Editable/EditableStringFieldWithSuggestions";
import {EditableMultiSelect} from "../../../../../components/Editable/EditableMultiSelect";
import {findClassTemplate} from "../../Calendar/CalendarUtil";
import {getPractitionerName} from "../../../../../util/ProviderUtil";
import {KensuProfileEditor} from "../../../../../components/table/KensuProfileEditor";
import ClassTemplateProto = space.kenko.proto.ClassTemplateProto;
import IClassTemplateProto = space.kenko.proto.IClassTemplateProto;
import {EditablePaymentPolicy} from "../Services/EditablePaymentPolicy";
import {EditablePriceField} from "../../../../../components/Editable/EditablePriceField";

// This is the page for editing (or adding) a classTemplate.
export const AddOrUpdateClassTemplate = () => {

  // If editing, the sku is a param. 
  const {idParam} = useParams();
  const {businessProfile} = useProviderProfile();

  const existingCategories = useMemo(() => {
    const categories: string[] = [];
    businessProfile?.studio?.classTemplates?.forEach(classTemplate => {
      if (classTemplate.category && categories.indexOf(classTemplate.category) < 0) {
        categories.push(classTemplate.category);
      }
    });
    return categories;
  }, [businessProfile])


  return <KensuProfileEditor<IClassTemplateProto>
      idParam={idParam}
      entityName={'Class'}
      entityNamePlural={'Classes'}
      entityListViewLink={'../classes'}
      archiveField={"archived"}
      getFromProfile={(profile, id) => findClassTemplate(profile, id)}
      getTitle={classTemplate => classTemplate.name}
      newBlankType={() => new ClassTemplateProto({
        paymentPolicy: {
          prepaid: {
            price: {
              currencyCode: 'USD',
              amount: 0
            }
          }
        }
      })}
      getRpcMethod={isUpdate => isUpdate ? 'update_class_template' : 'create_class_template'}
      getRpcPayload={classTemplate => MutateClassTemplateRequest.encode(new MutateClassTemplateRequest({
        classTemplate: classTemplate
      })).finish()}
  >

    <EditableStringField<IClassTemplateProto>
        label={'Name'}
        inputType={'text'}
        field={'name'}
    />

    <EditableLongTextField<IClassTemplateProto>
        label={'Description'}
        field={'description'}
    />

    <EditableStringFieldWithSuggestions<IClassTemplateProto>
        label={'Category'}
        field={'category'}
        suggestions={existingCategories}
        helpText={'Your classes will be categorized by this value in the booking flow.'}
    />

    <EditableStringField<IClassTemplateProto>
        label={'Length (minutes)'}
        inputType={'number'}
        field={'lengthMinutes'}
    />

    <EditableStringField<IClassTemplateProto>
        label={'Max attendees'}
        inputType={'number'}
        field={'maxAttendees'}
    />

    <EditablePriceField<IClassTemplateProto>
        getter={template => template.paymentPolicy?.prepaid?.price}
        setter={(template, value) => {
          return new ClassTemplateProto({
            ...template,
            paymentPolicy: {
              prepaid: {
                price: value
              }
            }
          })
        }}
        errorKey={'paymentPolicy.prepaid.price'}
        label={'Price (USD)'}
    />

  </KensuProfileEditor>
};

